/**
 * Lista de países (ISO-3166 alpha-2) usada nos formulários e exibições de grupo.
 * `flag` é o nome do arquivo SVG em /public/media/flags/.
 */
export interface Country {
  code: string;
  name: string;
  flag: string;
}

export const COUNTRIES: Country[] = [
  { code: "AF", name: "Afeganistão", flag: "afghanistan" },
  { code: "ZA", name: "África do Sul", flag: "south-africa" },
  { code: "AL", name: "Albânia", flag: "albania" },
  { code: "DE", name: "Alemanha", flag: "germany" },
  { code: "AD", name: "Andorra", flag: "andorra" },
  { code: "AO", name: "Angola", flag: "angola" },
  { code: "AG", name: "Antígua e Barbuda", flag: "antigua-and-barbuda" },
  { code: "SA", name: "Arábia Saudita", flag: "saudi-arabia" },
  { code: "DZ", name: "Argélia", flag: "algeria" },
  { code: "AR", name: "Argentina", flag: "argentina" },
  { code: "AM", name: "Armênia", flag: "armenia" },
  { code: "AU", name: "Austrália", flag: "australia" },
  { code: "AT", name: "Áustria", flag: "austria" },
  { code: "AZ", name: "Azerbaijão", flag: "azerbaijan" },
  { code: "BS", name: "Bahamas", flag: "bahamas" },
  { code: "BH", name: "Bahrein", flag: "bahrain" },
  { code: "BD", name: "Bangladesh", flag: "bangladesh" },
  { code: "BB", name: "Barbados", flag: "barbados" },
  { code: "BE", name: "Bélgica", flag: "belgium" },
  { code: "BZ", name: "Belize", flag: "belize" },
  { code: "BJ", name: "Benin", flag: "benin" },
  { code: "BY", name: "Bielorrússia", flag: "belarus" },
  { code: "BO", name: "Bolívia", flag: "bolivia" },
  { code: "BA", name: "Bósnia e Herzegovina", flag: "bosnia-and-herzegovina" },
  { code: "BW", name: "Botsuana", flag: "botswana" },
  { code: "BR", name: "Brasil", flag: "brazil" },
  { code: "BN", name: "Brunei", flag: "brunei" },
  { code: "BG", name: "Bulgária", flag: "bulgaria" },
  { code: "BF", name: "Burquina Faso", flag: "burkina-faso" },
  { code: "BI", name: "Burundi", flag: "burundi" },
  { code: "BT", name: "Butão", flag: "bhutan" },
  { code: "CV", name: "Cabo Verde", flag: "cape-verde" },
  { code: "CM", name: "Camarões", flag: "cameroon" },
  { code: "KH", name: "Camboja", flag: "cambodia" },
  { code: "CA", name: "Canadá", flag: "canada" },
  { code: "QA", name: "Catar", flag: "qatar" },
  { code: "KZ", name: "Cazaquistão", flag: "kazakhstan" },
  { code: "TD", name: "Chade", flag: "chad" },
  { code: "CL", name: "Chile", flag: "chile" },
  { code: "CN", name: "China", flag: "china" },
  { code: "CO", name: "Colômbia", flag: "colombia" },
  { code: "KM", name: "Comores", flag: "comoros" },
  { code: "CG", name: "Congo", flag: "republic-of-the-congo" },
  { code: "KP", name: "Coreia do Norte", flag: "north-korea" },
  { code: "KR", name: "Coreia do Sul", flag: "south-korea" },
  { code: "CI", name: "Costa do Marfim", flag: "ivory-coast" },
  { code: "CR", name: "Costa Rica", flag: "costa-rica" },
  { code: "HR", name: "Croácia", flag: "croatia" },
  { code: "CU", name: "Cuba", flag: "cuba" },
  { code: "DK", name: "Dinamarca", flag: "denmark" },
  { code: "DJ", name: "Djibuti", flag: "djibouti" },
  { code: "DM", name: "Dominica", flag: "dominica" },
  { code: "EG", name: "Egito", flag: "egypt" },
  { code: "SV", name: "El Salvador", flag: "el-salvador" },
  { code: "AE", name: "Emirados Árabes Unidos", flag: "united-arab-emirates" },
  { code: "EC", name: "Equador", flag: "ecuador" },
  { code: "ER", name: "Eritreia", flag: "eritrea" },
  { code: "SK", name: "Eslováquia", flag: "slovakia" },
  { code: "SI", name: "Eslovênia", flag: "slovenia" },
  { code: "ES", name: "Espanha", flag: "spain" },
  { code: "SZ", name: "Essuatíni", flag: "swaziland" },
  { code: "US", name: "Estados Unidos", flag: "united-states" },
  { code: "EE", name: "Estônia", flag: "estonia" },
  { code: "ET", name: "Etiópia", flag: "ethiopia" },
  { code: "FJ", name: "Fiji", flag: "fiji" },
  { code: "PH", name: "Filipinas", flag: "philippines" },
  { code: "FI", name: "Finlândia", flag: "finland" },
  { code: "FR", name: "França", flag: "france" },
  { code: "GA", name: "Gabão", flag: "gabon" },
  { code: "GM", name: "Gâmbia", flag: "gambia" },
  { code: "GH", name: "Gana", flag: "ghana" },
  { code: "GE", name: "Geórgia", flag: "georgia" },
  { code: "GD", name: "Granada", flag: "grenada" },
  { code: "GR", name: "Grécia", flag: "greece" },
  { code: "GT", name: "Guatemala", flag: "guatemala" },
  { code: "GN", name: "Guiné", flag: "guinea" },
  { code: "GQ", name: "Guiné Equatorial", flag: "equatorial-guinea" },
  { code: "GW", name: "Guiné-Bissau", flag: "guinea-bissau" },
  { code: "HT", name: "Haiti", flag: "haiti" },
  { code: "HN", name: "Honduras", flag: "honduras" },
  { code: "HU", name: "Hungria", flag: "hungary" },
  { code: "YE", name: "Iêmen", flag: "yemen" },
  { code: "MH", name: "Ilhas Marshall", flag: "marshall-island" },
  { code: "SB", name: "Ilhas Salomão", flag: "solomon-islands" },
  { code: "IN", name: "Índia", flag: "india" },
  { code: "ID", name: "Indonésia", flag: "indonesia" },
  { code: "IR", name: "Irã", flag: "iran" },
  { code: "IQ", name: "Iraque", flag: "iraq" },
  { code: "IE", name: "Irlanda", flag: "ireland" },
  { code: "IS", name: "Islândia", flag: "iceland" },
  { code: "IL", name: "Israel", flag: "israel" },
  { code: "IT", name: "Itália", flag: "italy" },
  { code: "JM", name: "Jamaica", flag: "jamaica" },
  { code: "JP", name: "Japão", flag: "japan" },
  { code: "JO", name: "Jordânia", flag: "jordan" },
  { code: "KI", name: "Kiribati", flag: "kiribati" },
  { code: "KW", name: "Kuwait", flag: "kuwait" },
  { code: "LA", name: "Laos", flag: "laos" },
  { code: "LS", name: "Lesoto", flag: "lesotho" },
  { code: "LV", name: "Letônia", flag: "latvia" },
  { code: "LB", name: "Líbano", flag: "lebanon" },
  { code: "LR", name: "Libéria", flag: "liberia" },
  { code: "LY", name: "Líbia", flag: "libya" },
  { code: "LI", name: "Liechtenstein", flag: "liechtenstein" },
  { code: "LT", name: "Lituânia", flag: "lithuania" },
  { code: "LU", name: "Luxemburgo", flag: "luxembourg" },
  { code: "MK", name: "Macedônia do Norte", flag: "republic-of-macedonia" },
  { code: "MG", name: "Madagascar", flag: "madagascar" },
  { code: "MY", name: "Malásia", flag: "malaysia" },
  { code: "MW", name: "Malaui", flag: "malawi" },
  { code: "MV", name: "Maldivas", flag: "maldives" },
  { code: "ML", name: "Mali", flag: "mali" },
  { code: "MT", name: "Malta", flag: "malta" },
  { code: "MA", name: "Marrocos", flag: "morocco" },
  { code: "MU", name: "Maurício", flag: "mauritius" },
  { code: "MR", name: "Mauritânia", flag: "mauritania" },
  { code: "MX", name: "México", flag: "mexico" },
  { code: "MM", name: "Mianmar", flag: "myanmar" },
  { code: "FM", name: "Micronésia", flag: "micronesia" },
  { code: "MZ", name: "Moçambique", flag: "mozambique" },
  { code: "MD", name: "Moldávia", flag: "moldova" },
  { code: "MC", name: "Mônaco", flag: "monaco" },
  { code: "MN", name: "Mongólia", flag: "mongolia" },
  { code: "ME", name: "Montenegro", flag: "montenegro" },
  { code: "NA", name: "Namíbia", flag: "namibia" },
  { code: "NR", name: "Nauru", flag: "nauru" },
  { code: "NP", name: "Nepal", flag: "nepal" },
  { code: "NI", name: "Nicarágua", flag: "nicaragua" },
  { code: "NE", name: "Níger", flag: "niger" },
  { code: "NG", name: "Nigéria", flag: "nigeria" },
  { code: "NO", name: "Noruega", flag: "norway" },
  { code: "NZ", name: "Nova Zelândia", flag: "new-zealand" },
  { code: "OM", name: "Omã", flag: "oman" },
  { code: "NL", name: "Países Baixos", flag: "netherlands" },
  { code: "PW", name: "Palau", flag: "palau" },
  { code: "PS", name: "Palestina", flag: "palestine" },
  { code: "PA", name: "Panamá", flag: "panama" },
  { code: "PG", name: "Papua-Nova Guiné", flag: "papua-new-guinea" },
  { code: "PK", name: "Paquistão", flag: "pakistan" },
  { code: "PY", name: "Paraguai", flag: "paraguay" },
  { code: "PE", name: "Peru", flag: "peru" },
  { code: "PL", name: "Polônia", flag: "poland" },
  { code: "PT", name: "Portugal", flag: "portugal" },
  { code: "KE", name: "Quênia", flag: "kenya" },
  { code: "KG", name: "Quirguistão", flag: "kyrgyzstan" },
  { code: "GB", name: "Reino Unido", flag: "united-kingdom" },
  { code: "CF", name: "República Centro-Africana", flag: "central-african-republic" },
  { code: "CD", name: "República Democrática do Congo", flag: "democratic-republic-of-congo" },
  { code: "DO", name: "República Dominicana", flag: "dominican-republic" },
  { code: "CZ", name: "República Tcheca", flag: "czech-republic" },
  { code: "RO", name: "Romênia", flag: "romania" },
  { code: "RW", name: "Ruanda", flag: "rwanda" },
  { code: "RU", name: "Rússia", flag: "russia" },
  { code: "WS", name: "Samoa", flag: "samoa" },
  { code: "SM", name: "San Marino", flag: "san-marino" },
  { code: "LC", name: "Santa Lúcia", flag: "st-lucia" },
  { code: "KN", name: "São Cristóvão e Névis", flag: "saint-kitts-and-nevis" },
  { code: "ST", name: "São Tomé e Príncipe", flag: "sao-tome-and-prince" },
  { code: "VC", name: "São Vicente e Granadinas", flag: "st-vincent-and-the-grenadines" },
  { code: "SN", name: "Senegal", flag: "senegal" },
  { code: "SL", name: "Serra Leoa", flag: "sierra-leone" },
  { code: "RS", name: "Sérvia", flag: "serbia" },
  { code: "SC", name: "Seychelles", flag: "seychelles" },
  { code: "SG", name: "Singapura", flag: "singapore" },
  { code: "SY", name: "Síria", flag: "syria" },
  { code: "SO", name: "Somália", flag: "somalia" },
  { code: "LK", name: "Sri Lanka", flag: "sri-lanka" },
  { code: "SD", name: "Sudão", flag: "sudan" },
  { code: "SS", name: "Sudão do Sul", flag: "south-sudan" },
  { code: "SE", name: "Suécia", flag: "sweden" },
  { code: "CH", name: "Suíça", flag: "switzerland" },
  { code: "SR", name: "Suriname", flag: "suriname" },
  { code: "TH", name: "Tailândia", flag: "thailand" },
  { code: "TW", name: "Taiwan", flag: "taiwan" },
  { code: "TJ", name: "Tajiquistão", flag: "tajikistan" },
  { code: "TZ", name: "Tanzânia", flag: "tanzania" },
  { code: "TL", name: "Timor-Leste", flag: "east-timor" },
  { code: "TG", name: "Togo", flag: "togo" },
  { code: "TO", name: "Tonga", flag: "tonga" },
  { code: "TT", name: "Trinidad e Tobago", flag: "trinidad-and-tobago" },
  { code: "TN", name: "Tunísia", flag: "tunisia" },
  { code: "TM", name: "Turcomenistão", flag: "turkmenistan" },
  { code: "TR", name: "Turquia", flag: "turkey" },
  { code: "TV", name: "Tuvalu", flag: "tuvalu" },
  { code: "UA", name: "Ucrânia", flag: "ukraine" },
  { code: "UG", name: "Uganda", flag: "uganda" },
  { code: "UY", name: "Uruguai", flag: "uruguay" },
  { code: "UZ", name: "Uzbequistão", flag: "uzbekistan" },
  { code: "VU", name: "Vanuatu", flag: "vanuatu" },
  { code: "VA", name: "Vaticano", flag: "vatican-city" },
  { code: "VE", name: "Venezuela", flag: "venezuela" },
  { code: "VN", name: "Vietnã", flag: "vietnam" },
  { code: "ZM", name: "Zâmbia", flag: "zambia" },
  { code: "ZW", name: "Zimbábue", flag: "zimbabwe" },
];

/**
 * URL do SVG da bandeira a partir do código do país.
 */
export function flagUrl(code: string): string {
  const country = COUNTRIES.find((c) => c.code === code);
  return country ? `/media/flags/${country.flag}.svg` : "";
}

/**
 * Nome legível do país a partir do código.
 */
export function countryName(code: string): string {
  return COUNTRIES.find((c) => c.code === code)?.name ?? code;
}
